export default __webpack_public_path__ + "static/media/card.1afa68b7.svg";